import { render, staticRenderFns } from "./DoctorListSetting.vue?vue&type=template&id=40654bc8&scoped=true&"
import script from "./DoctorListSetting.vue?vue&type=script&lang=js&"
export * from "./DoctorListSetting.vue?vue&type=script&lang=js&"
import style0 from "./DoctorListSetting.vue?vue&type=style&index=0&id=40654bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40654bc8",
  null
  
)

export default component.exports